import React from "react"
import { useForm, ValidationError } from "@formspree/react"
import { useGoogleReCaptcha } from "react-google-recaptcha-v3"
import { TextField, MailField, PhoneField, RadioField, NumberField, HiddenField, SubmitButton } from "./FormFields"
import { useLocation } from "../../hooks/use-location"
import FormSuccess from "./FormSuccess"
import FormWrapper from "./FormWrapper"

const formId = process.env.GATSBY_COURSE_FORM

const Form = ({ path, course }) => {
  const { href } = useLocation()
  const { executeRecaptcha } = useGoogleReCaptcha()
  const [state, handleSubmit] = useForm(formId, {
    data: { "g-recaptcha-response": executeRecaptcha }
  })

  if (state.succeeded) {
    return (
      <FormSuccess title="¡Gracias por tu tiempo!" survey="courses">
        <p id="generatelead">Te contactaremos tan pronto sea posible. Si tienes más dudas envía un correo a <span className="text-bold">hola@derevo.com.mx</span></p>
      </FormSuccess>
    )
  }

  const modalityOptions = [
    { value: 'Individual', text: 'Individual' },
    { value: 'Empresa', text: 'Empresa' }
  ]

  return (
    <form id="leadform" className="form-fields" onSubmit={handleSubmit}>
      <TextField id="name" text="Nombre" required={true} />
      <MailField id="email" text="Correo electrónico" required={true} />
      <PhoneField id="phone" text="Teléfono" />
      <RadioField id="modality" text="Modalidad" options={modalityOptions} selected={0} />
      <TextField id="company" text="Nombre de la empresa" required={true} />
      <NumberField id="people" text="¿Para cuántas personas?" required={true} placeholder={0} />
      <HiddenField id="service" value="Cursos" />
      <HiddenField id="technology" value={path} />
      <HiddenField id="course" value={course} />
      <HiddenField id="site" value={href} />
      <HiddenField id="subject" value={`Lead {{ company }} (Cursos {{ modality }})`} />
      <ValidationError className="errors" errors={state.errors} />
      <SubmitButton text={ state.submitting ? `Enviando...` : `Enviar` } disabled={state.submitting} />
    </form>
  )
}

const CourseForm = (props) => (
  <FormWrapper>
    <Form {...props}/>
  </FormWrapper>
)

export default CourseForm